import { contactInfo } from '@/mocks/home';

export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 tracking-wide">联系我们</h2>
          <p className="mt-2 text-sm text-foreground-500">有好片推荐、资源分享或合作意向？欢迎随时联系</p>
        </div>
        <div className="max-w-lg mx-auto bg-background-100 rounded-lg border border-background-200/70 p-6 md:p-8 text-center">
          <div className="w-16 h-16 mx-auto mb-5 rounded-full bg-primary-500/10 flex items-center justify-center">
            <i className="ri-mail-send-line text-2xl text-primary-400"></i>
          </div>
          <p className="text-sm text-foreground-600 leading-relaxed mb-6">{contactInfo.description}</p>
          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <div className="flex items-center justify-center gap-2 px-5 py-3 bg-background-50 rounded-md border border-background-200 cursor-pointer hover:border-primary-400/30 transition-colors">
              <i className="ri-mail-line text-primary-400"></i>
              <span className="text-sm text-foreground-600">{contactInfo.email}</span>
            </div>
            <div className="flex items-center justify-center gap-2 px-5 py-3 bg-background-50 rounded-md border border-background-200 cursor-pointer hover:border-primary-400/30 transition-colors">
              <i className="ri-wechat-line text-primary-400"></i>
              <span className="text-sm text-foreground-600">{contactInfo.wechat}</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}